<template>
  <div class="container">
    <table class="table table-striped" style="border: 1px solid #000;">
      <thead>
        <tr>
          <th scope="col" colspan="2">Variables</th>
          <th scope="col">{{ Yeartwo }}</th>
          <th scope="col">{{ YearOne }}</th>
          <th scope="col">{{ varEntorno }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" colspan="2">{{ textOne }}</th>
          <td>
            <input
              :disabled="readOnly"
              class="input"
              v-model="porcentajeRecuperacion.inputOne"
            />
          </td>
          <td>
            <input
              :disabled="readOnly"
              class="input"
              v-model="porcentajeRecuperacion.inputTwo"
            />
          </td>
          <td>
            <input
              :disabled="readOnly"
              v-model="porcentajeRecuperacion.inputThree"
              class="input"
            />
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textTwo }}</th>
          <td>
            {{ sumaOne }}
          </td>
          <td>
            {{ sumaTwo }}
          </td>
          <td>
            {{ sumaThree }}
          </td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textThree }}</th>
          <td>{{ intPorcentajeOne }}%</td>
          <td>{{ intPorcentajeTwo }}%</td>
          <td>{{ intPorcentajeThree }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import store from "../../../../../store";
export default {
  props: ["porcentajeRecuperacion", "ceseRetiro", "readOnly"],
  data() {
    return {
      textOne:
        "(a) N° de funcionarios que ingresan a la dotación del Servicio año t",
      textTwo:
        "(b) N° de funcionarios que cesan o se retiran del Servicio por cualquier causal año t",
      textThree: "Porcentaje de recuperación (a/b)",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",
      porcentajeOne: "",
      porcentajeTwo: "",
      porcentajeThree: "",
      porcentaje: "100",
      intPorcentajeOne: null,
      intPorcentajeTwo: null,
      intPorcentajeThree: null,
      arrayFather: null,
      sumaOne: 0,
      sumaTwo: 0,
      sumaThree: 0,
    };
  },

  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
    // this.arrayFunction();
  },
  updated() {
    this.sumaOne =
      parseInt(this.ceseRetiro.inputOne) +
      parseInt(this.ceseRetiro.inputFour) +
      parseInt(this.ceseRetiro.inputSeven) +
      parseInt(this.ceseRetiro.inputThirteen) +
      parseInt(this.ceseRetiro.inputTen);

    this.sumaTwo =
      parseInt(this.ceseRetiro.inputTwo) +
      parseInt(this.ceseRetiro.inputFive) +
      parseInt(this.ceseRetiro.inputEight) +
      parseInt(this.ceseRetiro.inputEleven) +
      parseInt(this.ceseRetiro.inputFourteen);

    this.sumaThree =
      parseInt(this.ceseRetiro.inputThree) +
      parseInt(this.ceseRetiro.inputSix) +
      parseInt(this.ceseRetiro.inputNine) +
      parseInt(this.ceseRetiro.inputTwelve) +
      parseInt(this.ceseRetiro.inputFifteen);

    // Primer porcentaje
    this.porcentajeOne =
      (parseInt(this.porcentajeRecuperacion.inputOne) /
        parseInt(this.sumaOne)) *
      parseInt(this.porcentaje);
    this.intPorcentajeOne = this.porcentajeOne.toFixed(2);

    //Segundo Porcentaje
    this.porcentajeTwo =
      (parseInt(this.porcentajeRecuperacion.inputTwo) /
        parseInt(this.sumaTwo)) *
      parseInt(this.porcentaje);
    this.intPorcentajeTwo = this.porcentajeTwo.toFixed(2);

    //Tercer Porcentaje
    this.porcentajeThree =
      (parseInt(this.porcentajeRecuperacion.inputThree) /
        parseInt(this.sumaThree)) *
      parseInt(this.porcentaje);
    this.intPorcentajeThree = this.porcentajeThree.toFixed(2);

    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       title: this.textOne,
    //       anioTwo: this.inputOne,
    //       anioOne: this.inputTwo,
    //       anio: this.inputThree,
    //     },
    //     {
    //       title: this.textTwo,
    //       anioTwo: this.inputFour,
    //       anioOne: this.inputFive,
    //       anio: this.inputSix,
    //     },
    //     {
    //       title: this.textThree,
    //       anioTwo: `${this.intPorcentajeOne}%`,
    //       anioOne: `${this.intPorcentajeTwo}%`,
    //       anio: `${this.intPorcentajeThree}%`,
    //     },
    //   ],
    //   nameTable: "porcentajeRecuperacion",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: left !important;
  font-size: 14px !important ;
}

.div {
  border: 1px solid #000;
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}
</style>
